<template>
  <div class="h-full dark">
    <RoundFilterUtils />
    <Svgs />
    <SplashComponent v-if="!canGoIntoApp" />
    <div
      v-else
      class="w-full h-full opacity-0 hidden"
      :class="{ '!block !opacity-100': canGoIntoApp }"
    >
      <div class="h-full w-full">
        <GiftCardDirect platform="netflix" />
      </div>
      <div :key="pageContentKey">
        <TransactionDetailsComponent />
        <PaymentLinkShower />
        <PromptModal />
        <LinkOpener />
        <ChoiceModal />
        <LoadingPromptModal />
      </div>
    </div>
    <ToastNotification />
  </div>
</template>

<script>
import LinkOpener from './components/appComponent/LinkOpener.vue'
import SplashComponent from './components/appComponent/SplashComponent.vue'
import PaymentLinkShower from './components/transaction/PaymentLinkShower.vue'
import TransactionDetailsComponent from './components/transaction/TransactionDetailsComponent.vue'
import ChoiceModal from './components/utils/ChoiceModal.vue'
import LoadingPromptModal from './components/utils/LoadingPromptModal.vue'
import PromptModal from './components/utils/PromptModal.vue'
import ToastNotification from './components/utils/ToastNotification.vue'
import RoundFilterUtils from './components/utils/RoundFilterUtils.vue'
import GiftCardDirect from './components/transaction/transactionLaunch/GiftCardDirect.vue'
import Svgs from './components/utils/Svgs.vue'

export default {
  name: 'App',
  metaInfo: {
    link: [],
  },
  components: {
    PromptModal,
    ToastNotification,
    TransactionDetailsComponent,
    SplashComponent,
    LoadingPromptModal,
    ChoiceModal,
    LinkOpener,
    PaymentLinkShower,
    RoundFilterUtils,
    GiftCardDirect,
    Svgs,
  },
  data() {
    return {
      pageContentKey: 'initial',
      appInitialized: false,
      pages: [
        {
          path: '',
          requirements: [],
          redirectTo: [],
          themeColor: {
            '': '#242c3b',
            '#bottomsheet': '#181E29',
            '#modalvisible': '#181E29',
            '#tourguide': '#181E29',
            '#chat': '#fff',
          },
        },
      ],
      userTheme: 'light',
    }
  },
  beforeMount() {
    // this.$router.push({ path: "/", replace: true }).catch(() => {});
  },
  async mounted() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    await this.initializeApp()
    this.initListeners()
    this.loadLottiePlayer()
  },
  beforeUnmount() {},
  methods: {
    async initializeApp() {
      this.$Events.dispatchEvent('logout_requested')
      // this.$Events.dispatchEvent('clean_all_data_requested')
    },
    async handleRoute(newRoute = this.$route) {
      return
    },
    initListeners() {
      this.$Events.handleEvent('lang_changed', () => {
        // this.key = Date.now();
        this.$forceUpdate()
      })
      this.$Events.handleEvent('color_theme_changed', () => {
        this.key = Date.now()
        // this.$forceUpdate();
      })
    },
    addPicErrorListener() {
      let isClient = false
      try {
        if (window) isClient = true
      } catch (error) {
        console.log(error)
      }
      if (!isClient) return
      const picsNotWathingError = document.querySelectorAll(
        'img:not([watchimageerror])',
      )
      picsNotWathingError.forEach(pic => {
        pic.addEventListener('error', () => {
          pic.setAttribute('goterror', 'true')
        })
        pic.setAttribute('watchimageerror', 'false')
        pic.setAttribute('onerror', 'this.style.opacity = 0')
      })
    },
    loadLottiePlayer() {
      const scriptSelector = 'script[name="lottieScript"]'
      const lottieScriptAlreadyAdded = document.querySelector(scriptSelector)
      if (lottieScriptAlreadyAdded) return
      const lottieScript = document.createElement('script')
      lottieScript.setAttribute('name', 'lottieScript')
      lottieScript.setAttribute('src', '/plugins/lottie-player.js')
      document.head.appendChild(lottieScript)
    },
    resetThemeColor(pageData) {
      if (!this.appInitialized) return
      const hash = this.$route.hash || ''

      let themeColor = pageData.themeColor['']
      Object.keys(pageData.themeColor).forEach(pageHash => {
        const hashMatch = new RegExp(pageHash).test(hash)
        if (!hashMatch) return
        themeColor = pageData.themeColor[pageHash]
      })
      console.log(themeColor)
      if (themeColor) {
        this.$Commons.setThemeColor(themeColor)
      }

      let bottomNavColor
      if (pageData.bottomNavColor) pageData.bottomNavColor['']
      Object.keys(pageData.bottomNavColor || {}).forEach(pageHash => {
        const hashMatch = new RegExp(pageHash).test(hash)
        if (!hashMatch) return
        bottomNavColor = pageData.themeColor[pageHash]
      })
      if (bottomNavColor) {
        document.body.style.backgroundColor = bottomNavColor
      } else {
        document.body.style.removeProperty('background-color')
      }
    },
  },

  computed: {
    canGoIntoApp() {
      return true
      return this.appInitialized
    },
  },
  watch: {
    $route: {
      deep: true,
      async handler(newValue) {
        this.handleRoute(newValue)
      },
    },
    canGoIntoApp() {
      this.$Events.dispatchEvent('app_initialized')
    },
  },
}
</script>
<!-- 
<style>
:root {
  /*Input components*/
  --inputcomponent-height: 55px;
  --inputcomponent-margin-top: 10px;
  --inputcomponent-margin-bottom: 10px;
  --inputcomponent-background-color: #242c3b22;
  /* --inputcomponent-background-color: #fff8; */
  --inputcomponent-border-color: #0000;
  --inputcomponent-border: solid 2px var(--inputcomponent-border-color);
  --inputcomponent-border-radius: 1.4rem;
  --inputcomponent-width: 100%;
  --inputcomponent-focus-label-color: var(--title-description-color);
  --inputcomponent-label-position-top: 14px;
  --inputcomponent-label-font-size: 14px;
  --inputcomponent-focus-label-font-size: 12px;
}

</style> -->
